import { basicURL } from "./APIConfig";
import { store } from "../redux/store";
import { performLogout } from "../utils/logout";

/** Must match mic-backend `UNIVERSITY_ACCESS_INVALID_CODE` */
const UNIVERSITY_ACCESS_INVALID_CODE = "UNIVERSITY_ACCESS_INVALID";

const readPersistedAccessToken = () => {
  try {
    const raw = localStorage.getItem("persist:root");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const authRaw = parsed?.auth;
    if (!authRaw) return null;
    const auth = typeof authRaw === "string" ? JSON.parse(authRaw) : authRaw;
    const token = auth?.access_token;
    if (!token) return null;
    const normalized = String(token).trim();
    if (!normalized || normalized === "undefined" || normalized === "null") return null;
    return normalized;
  } catch (_) {
    return null;
  }
};

export const CallAPI = ({
  method = "GET",
  url,
  body,
  formData = null,
  token,
  contentType = "application/json",
  setProgress = () => {},
}) => {
  return new Promise((resolve, reject) => {
    const fromStore = store.getState().auth?.access_token;
    const access_token =
      token ||
      (fromStore && String(fromStore).trim() && String(fromStore).trim() !== "undefined"
        ? String(fromStore).trim()
        : readPersistedAccessToken());
    let bodyData = null;
    const isFormData = !!formData;

    if (body && !isFormData) {
      bodyData = JSON.stringify(body);
    }
    if (isFormData) {
      bodyData = formData;
    }

    const xhr = new XMLHttpRequest();
    xhr.open(method, `${basicURL}${url}`, true);
    console.log("network: ", `${basicURL}${url}`);

    // Do not set Cache-Control/Pragma on XHR: extra headers widen CORS preflight and
    // must match server allowedHeaders. Use query cache-bust on specific GETs instead.

    // Set up headers
    if (access_token) {
      xhr.setRequestHeader("Authorization", `Bearer ${access_token}`);
    }
    // For FormData, let the browser set the correct multipart boundary.
    if (!isFormData && contentType) {
      xhr.setRequestHeader("Content-Type", contentType);
    }

    // Track upload progress
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentComplete = event.loaded / event.total;
        setProgress(percentComplete);
      }
    };

    xhr.onload = () => {
      console.log("onload event fired with status:", xhr.status);
      const responseContentType = xhr.getResponseHeader("Content-Type");
      let data = xhr.responseText;

      // Try parsing JSON response if content type is JSON
      if (responseContentType?.includes("application/json")) {
        try {
          data = JSON.parse(xhr.responseText);
        } catch (parseError) {
          console.error("Error parsing JSON:", parseError);
        }
      }

      // Session invalid: prof removed from university, university deleted/inactive, etc.
      if (
        xhr.status === 403 &&
        typeof data === "object" &&
        data &&
        data.code === UNIVERSITY_ACCESS_INVALID_CODE
      ) {
        const msg = typeof data.message === "string" ? data.message : undefined;
        performLogout(msg);
        resolve(data);
        return;
      }

      // Token no longer valid (e.g. user deleted) — only when a token was sent
      if (xhr.status === 401 && access_token) {
        performLogout();
        resolve(data);
        return;
      }

      // Resolve for success status
      if (xhr.status >= 200 && xhr.status < 300) {
        setProgress(0);
        resolve(data);
      } else {
        console.log("Request rejected with status:", xhr.status);
        resolve(data);
      }
    };

    // Handle network error
    xhr.onerror = () => {
      resolve({
        status: xhr.status || 0,
        statusText: xhr.statusText || "Network error occurred",
        data: null,
      });
    };

    // Send the request
    try {
      xhr.send(bodyData);
    } catch (sendError) {
      console.error("Error sending request:", sendError);
      reject({
        status: 0,
        statusText: "Failed to send request",
        data: null,
      });
    }
  });
};
